import {
    useAppStore as baseUseAppStore
} from 'commercial-web-client-utilities/dist/store/app';
import {
    useDeveloperSettingsStore as baseUseDeveloperSettingsStore
} from 'commercial-web-client-utilities/dist/store/developer-settings';

import type { AppStore, DeveloperSettingsStore } from '@/types';

export function useAppStore(): AppStore {
    return baseUseAppStore() as unknown as AppStore;
}

export function useDeveloperSettingsStore(): DeveloperSettingsStore {
    return baseUseDeveloperSettingsStore() as unknown as DeveloperSettingsStore;
}

export { usePlanComparisonToolStore, initialSteps } from './plan-comparison-tool';
